import { api } from './api';

export const getAllServices = async () => {
  const queryString = new URLSearchParams({
    active_services: true,
    limit: 100,
  }).toString();
  return api.get(`/api/services/?${queryString}`);
}; 